import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

export const getPractitionerNameAndTitle = (practitioner: AppointmentPractitioner): string => {
   const { firstName, lastName, title } = practitioner;

   if (title) {
      return `${title} ${firstName.asString()} ${lastName.asString()}`;
   }

   return `${firstName.asString()} ${lastName.asString()}`;
};

export const getPractitionerSpecialtyNames = (practitioner: AppointmentPractitioner): string => {
   const { specialtyNames } = practitioner;
   return specialtyNames.map((specialtyName) => specialtyName).join(', ');
};
